var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 7.8125C12.0002 7.625 11.8127 7.4375 11.6252 7.4375H8.56274V4.375C8.56274 4.1875 8.37524 4 8.18774 4H7.81274C7.59399 4 7.43774 4.1875 7.43774 4.375V7.4375H4.37524C4.15649 7.4375 4.00024 7.625 4.00024 7.8125V8.1875C4.00024 8.40625 4.15649 8.5625 4.37524 8.5625H7.43774V11.625C7.43774 11.8438 7.59399 12 7.81274 12H8.18774C8.37524 12 8.56274 11.8438 8.56274 11.625V8.5625H11.6252C11.8127 8.5625 12.0002 8.40625 12.0002 8.1875V7.8125ZM15.7502 8C15.7502 3.71875 12.2815 0.25 8.00024 0.25C3.71899 0.25 0.250244 3.71875 0.250244 8C0.250244 12.2812 3.71899 15.75 8.00024 15.75C12.2815 15.75 15.7502 12.2812 15.7502 8ZM14.7502 8C14.7502 11.7188 11.719 14.75 8.00024 14.75C4.28149 14.75 1.25024 11.75 1.25024 8C1.25024 4.3125 4.25024 1.25 8.00024 1.25C11.6877 1.25 14.7502 4.28125 14.7502 8Z",
    fill: "#71767D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.80e68bce.svg";
export { ForwardRef as ReactComponent };